import { useEffect } from 'react';
import {
  BrowserLocalRecordingRecovery,
  defaultBrowserLocalRecordingRecovery,
} from '../utils/browserLocalRecordingRecovery';

const reportBrowserLocalRecordingRecoveryCleanupFailure = (error: unknown): void => {
  console.warn('Could not clean up expired browser-local recording recovery:', error);
};

export const useBrowserLocalRecordingRecoveryCleanup = (
  recovery: BrowserLocalRecordingRecovery = defaultBrowserLocalRecordingRecovery,
  reportFailure: (error: unknown) => void = reportBrowserLocalRecordingRecoveryCleanupFailure
): void => {
  useEffect(() => {
    recovery.cleanupExpired().catch(reportFailure);
  }, [recovery, reportFailure]);
};
